// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rq-0";